export const MAX_RDO_PHOTOS = 6;
export const MAX_RDO_PHOTO_BYTES = 10 * 1024 * 1024;
export const RDO_PHOTO_TYPES = ["image/png", "image/jpeg"];

export function photoSlotsLeft(current: number): number {
	return Math.max(0, MAX_RDO_PHOTOS - current);
}

export function isPhotoLimitReached(current: number): boolean {
	return photoSlotsLeft(current) === 0;
}

export function formatPhotoCount(current: number): string {
	return `${Math.min(current, MAX_RDO_PHOTOS)}/${MAX_RDO_PHOTOS}`;
}

export function togglePhotoSelection(
	selected: readonly string[],
	id: string,
	current: number,
): string[] {
	if (selected.includes(id)) {
		return selected.filter((item) => item !== id);
	}
	if (selected.length >= photoSlotsLeft(current)) {
		return [...selected];
	}
	return [...selected, id];
}

export function canSelectMorePhotos(
	selected: readonly string[],
	current: number,
): boolean {
	return selected.length < photoSlotsLeft(current);
}

export function isAllowedRdoPhoto(file: File): boolean {
	return RDO_PHOTO_TYPES.includes(file.type) && file.size <= MAX_RDO_PHOTO_BYTES;
}
